<script>

    import Box from '../../components/Box.svelte';

    import { _, locale } from 'svelte-i18n';

    import Icon from '../Icon.svelte';
    import appointmentIcon from '../../assets/icons/appointment.svg?raw';
    import treatmentIcon from '../../assets/icons/treatment.svg?raw';
    import employeeIcon from '../../assets/icons/employee.svg?raw';

    import { DateTime } from 'luxon'

    let { appointment, children } = $props();

</script>

<Box>
    <div class='appointment'>
        <Icon data={appointmentIcon} />
        
        <h3>
            {$_('data_at_time', { values: {
                date: DateTime.fromSQL(appointment.date).toLocaleString(DateTime.DATE_FULL, { locale: $locale }),
                time: DateTime.fromSQL(appointment.time).toLocaleString(DateTime.TIME_SIMPLE, { locale: $locale })
            }})}
        </h3>

        {#if appointment.treatment?.name}
            <Icon data={treatmentIcon} />

            <p>
                {appointment.treatment.name}
            </p>
        {/if}

        {#if appointment.employee?.id}
            <Icon data={employeeIcon} /> 

            <p>
                {appointment.employee.name}
            </p>
        {/if}
    </div>

    {@render children?.()}
</Box>

<style>

    .appointment {
        display: grid;
        grid-template-columns: min-content 1fr;
        align-items: center;
        gap: 0.3em 0.8em;
    }

    .appointment > * {
        margin: 0;
    }

    .appointment.cancelled h3 {
        text-decoration: line-through;
        text-decoration-color: red;
        text-decoration-thickness: 4px;
    }


</style>